import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GetDeliveryAddress.scss';
import { DeliveryAddressDataContext } from '../../context-api/DeliveryAddressDataProvider';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import {
  DELETE_ADDRESS_SUCCESSFULLY,
  API_NETWORK_ERROR,
  localStorageKeys,
} from '../../global/constants';
import jwt_decode from 'jwt-decode';
import { Error404 } from '../Error404/Error404';
import { isMobile, isDesktop, isIpad } from './../../global/ScreenSizeHelper';
import responseErrorMapping from './../../global/error.response.mapping';
import { Alert } from '@mui/material';

const GetDeliveryAddress = () => {
  const {
    getDeliveryAddressApiHandler,
    getDeliveryAddressListResponse,
    updateDeliveryAddressApiHandler,
    updateDeliveryAddressResponse,
    setUpdateDeliveryAddressResponse,
    setDeleteDeliveryAddressResponse,
    deleteDeliveryAddressResponse,
    deleteDeliveryAddressApiHandler,
  } = useContext(DeliveryAddressDataContext);
  const { TOKEN } = localStorageKeys;
  const hasTokens = localStorage.getItem(TOKEN);
  const { onLogout } = useContext(LoginDataContext);
  const { data, success, errorMessage } = getDeliveryAddressListResponse;
  const {
    isLoading: checkLoading,
    data: checkData,
    success: checkSuccess,
    errorMessage: checkErrorMessage,
  } = updateDeliveryAddressResponse;
  const {
    isLoading: loadingCheck,
    data: dataCheck,
    success: successCheck,
    message: errorMessageCheck,
  } = deleteDeliveryAddressResponse;
  const [firstLastName, setFirstLastName] = useState({});
  const { firstName, lastName } = firstLastName;
  const navigate = useNavigate();
  const RedirectToLogin = async () => await navigate('/login');
  const triggerLogout = async () => await onLogout();
  const OpenSucessAlert =
    successCheck === true &&
    errorMessageCheck === 'Address deleted successfully and status updated';

  const handleClose = () => {
    setDeleteDeliveryAddressResponse({});
  };

  const TriggerGetDeliveryAddressAPI = async (email, firstName, lastName) => {
    await setFirstLastName({ firstName, lastName });
    await getDeliveryAddressApiHandler(email);
  };

  useEffect(() => {
    setDeleteDeliveryAddressResponse({});
    setUpdateDeliveryAddressResponse({});
    const decodedToken = jwt_decode(hasTokens);
    const { email, firstName, lastName } = decodedToken;
    TriggerGetDeliveryAddressAPI(email, firstName, lastName);
  }, []);

  if (success === false && errorMessage === 'Authentication failed!') {
    console.log('-------I AM RUNNING ');
    triggerLogout();
    RedirectToLogin();
  }
  if (checkSuccess === false && checkErrorMessage === 'Authentication failed!') {
    console.log('-------I HAVE TO RUN');
    triggerLogout();
    RedirectToLogin();
  }

  if (checkSuccess === true) {
    window.location.reload();
  }

  // this method onSetDefaultButton will be triggred to update default address
  const onClickDefaultButton = async (id, list) => {
    if (!hasTokens) {
      triggerLogout();
      RedirectToLogin();
    }
    if (hasTokens) {
      const decodedToken = jwt_decode(hasTokens);
      const { email } = decodedToken;
      const payload = { email: email, _id: id };
      await updateDeliveryAddressApiHandler(payload, list);
    }
  };

  const onClickRemoveButton = async (id, list) => {
    if (!hasTokens) {
      triggerLogout();
      RedirectToLogin();
    }
    if (hasTokens) {
      const decodedToken = jwt_decode(hasTokens);
      const { email } = decodedToken;
      const payload = { email: email, _id: id };
      await deleteDeliveryAddressApiHandler(payload, list);
    }
  };

  const StyleMobileIpad = {
    border: '1px solid #CCCCCC',
    borderRadius: '5px',
    margin: '5px 4% 5px 4%',
    overflow: 'hidden',
    padding: '10px',
  };

  const StyleForDefault = {
    ...StyleMobileIpad,
    border: '2px solid #FF7A28',
  };
  const StyleDesktop = {
    border: '1px solid #CCCCCC',
    width: '180px',
    // height: '140px',
    margin: '10px 10px 10px 0px',
    borderRadius: '5px',
    overflow: 'hidden',
    padding: '15px',
  };
  const StyleDefaultDesktop = {
    ...StyleDesktop,
    border: '2px solid #FF7A28',
  };

  const StyleNoAddressFound = {
    border: '1px solid #CCCCCC',
    height: '75px',
    borderRadius: '5px',
    margin: isMobile || isIpad ? '5px 4% 5px 4%' : '5px 4% 5px 0%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    backgroundColor: '#F8F8F8',
    color: '#CCCCCC',
  };
  const onSucessAlert = OpenSucessAlert && (
    <Alert
      id='warning-box'
      severity='success'
      sx={{
        width: isMobile ? 'auto' : '386px',
        border: 'solid 2px green',
        margin: isMobile || isIpad ? '4% 4% 2% 4%' : '5px 0px 5px 0px',
        color: 'green',
      }}
      onClose={handleClose}
    >
      {' '}
      {DELETE_ADDRESS_SUCCESSFULLY}
    </Alert>
  );

  if (
    (success == false && errorMessage === API_NETWORK_ERROR) ||
    (checkSuccess === false && checkErrorMessage === API_NETWORK_ERROR) ||
    (successCheck === false && errorMessageCheck === API_NETWORK_ERROR)
  ) {
    return <Error404 />;
  }

  if (success === false && errorMessage === 'User donst not exist') {
    return <div style={StyleNoAddressFound}> {responseErrorMapping(errorMessage)}</div>;
  }

  const addresses = data?.data || [];
  const defaultAddressIndex = addresses.findIndex((n) => n.isDefault_address === true);

  // Sorting address which has isDefault_address === true should come on first position in the list
  const sortedAddresses = [];
  if (defaultAddressIndex > -1) {
    sortedAddresses[0] = addresses[defaultAddressIndex];
    let j = 1;
    for (var i = 0; i < addresses.length; i++) {
      if (i === defaultAddressIndex) {
        continue;
      } else {
        sortedAddresses[j++] = addresses[i];
      }
    }
  }

  if (isMobile) {
    return (
      <div style={{ marginBottom: '90px' }}>
        {OpenSucessAlert && onSucessAlert}
        {sortedAddresses.map((n, i) => (
          <div key={i} style={n.isDefault_address ? StyleForDefault : StyleMobileIpad}>
            <div
              style={{
                color: 'black',
                fontSize: '12px',
                fontFamily: 'Roboto Medium',
                letterSpacing: '0.5px',
                fontWeight: 500,
                textTransform: 'capitalize',
              }}
            >
              {n.full_name ? n.full_name : `${firstName} ${lastName}`}
            </div>
            <div
              style={{
                marginTop: '5px',
                marginBottom: '5px',
                color: '#464343',
                fontSize: '12px',
                fontFamily: 'Roboto Regular',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
              }}
            >
              {n.Geolocation.formattedAddress}
            </div>
            <div
              style={{
                color: '#464343',
                fontSize: '10px',
                fontFamily: 'Roboto Medium',
                letterSpacing: '0.5px',
                fontWeight: '500',
                marginBottom: '2px',
              }}
            >
              Apt# : {n.apt_no}
            </div>
            {n.isDefault_address && (
              <div
                style={{
                  color: '#FF7A28',
                  fontSize: '12px',
                  fontFamily: 'Roboto Medium',
                  letterSpacing: '0.5px',
                  fontWeight: '500',
                  marginTop: '5px',
                }}
              >
                {' '}
                Default address
              </div>
            )}
            {!n.isDefault_address && (
              <div>
                {' '}
                <button
                  className='button-get-delivery-address'
                  onClick={() => {
                    onClickRemoveButton(n._id, sortedAddresses);
                  }}
                >
                  Remove
                </button>
                <button
                  className='button-get-delivery-address'
                  onClick={() => {
                    onClickDefaultButton(n._id, sortedAddresses);
                  }}
                >
                  {' '}
                  Set as Default
                </button>{' '}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      {OpenSucessAlert && onSucessAlert}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          overflow: 'hidden',
          marginLeft: isIpad ? '20px' : '0px',
        }}
      >
        {sortedAddresses.map((n, i) => (
          <div key={i} style={n.isDefault_address ? StyleDefaultDesktop : StyleDesktop}>
            <div
              style={{
                color: 'black',
                fontSize: '14px',
                fontFamily: 'Roboto Medium',
                letterSpacing: '0.5px',
                textTransform: 'capitalize',
              }}
            >
              {n.full_name ? n.full_name : `${firstName} ${lastName}`}
            </div>
            <div
              style={{
                marginTop: '10px',
                marginBottom: '10px',
                color: '#464343',
                fontSize: '13px',
                fontFamily: 'Roboto Regular',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
              }}
            >
              {n.Geolocation.formattedAddress}
            </div>
            <div
              style={{
                color: '#464343',
                fontSize: '12px',
                fontFamily: 'Roboto Medium',
                letterSpacing: '0.5px',
                marginBottom: '20px',
              }}
            >
              Apt# : {n.apt_no}
            </div>
            {n.isDefault_address && (
              <div
                style={{
                  color: '#FF7A28',
                  fontSize: '12px',
                  fontFamily: 'Roboto Medium',
                  letterSpacing: '0.5px',
                }}
              >
                {' '}
                Default address
              </div>
            )}
            {!n.isDefault_address && (
              <div>
                {' '}
                <button
                  className='button-get-delivery-address'
                  onClick={() => {
                    onClickRemoveButton(n._id, sortedAddresses);
                  }}
                >
                  Remove
                </button>
                <button
                  className='button-get-delivery-address'
                  onClick={() => {
                    onClickDefaultButton(n._id, sortedAddresses);
                  }}
                >
                  {' '}
                  Set as Default
                </button>{' '}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default GetDeliveryAddress;
